export const SUBSCRIBE_URL =
  "https://ezzyfeedback.us17.list-manage.com/subscribe/post?u=64c23096f4dc1dd3c4169b140&id=5277d2b126";

export const FACEBOOK_URL = "https://www.facebook.com/EzzyFeedback";
export const TWITTER_URL = "https://twitter.com/EzzyFeedback";
export const LINKEDIN_URL = "https://www.linkedin.com/company/ezzyfeedback";
export const INSTAGRAM_URL = "https://www.instagram.com/ezzyfeedback_app";
export const YOUTUBE_URL =
  "https://www.youtube.com/channel/UCiRiuqzYn6Md2wGpQ-HoYdg";
